// extracted by mini-css-extract-plugin
export var box = "_1y-1";
export var checkboxRow = "_1y-8";
export var checked = "_1y-2";
export var descriptionSpacer = "_1y-a";
export var disabled = "_1y-3";
export var icon = "_1y-6";
export var input = "_1y-0";
export var labelSpacer = "_1y-9";
export var medium = "_1y-5";
export var small = "_1y-4";
export var text = "_1y-7";